import './custom.scss'
import Vue from 'vue'
import VueRouter from "vue-router";
import App from './App.vue'

require('es6-promise').polyfill();
//import 'es6-promise/auto'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import Ads from 'vue-google-adsense'
import ConstellationPage from "./components/ConstellationPage.vue";
import ConstellationListPage from "./components/ConstellationListPage.vue";
import LiveSkyPage from "./components/LiveSkyPage.vue";
import LiveSkyPageSettings from "./components/LiveSkyPageSettings.vue";

Vue.use(require('vue-script2'))
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Ads.Adsense)

Vue.config.productionTip = false

const router = new VueRouter({
  routes: [
    { path: '/constellations', components: {default: ConstellationListPage, settings: null}},
    { path: '/constellations/:con', components: {default: ConstellationPage, settings: null}},
    { path: '/livesky', components: {default: LiveSkyPage, settings: LiveSkyPageSettings}}
  ]
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
